

import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import HomeIcon from "@material-ui/icons/Home";
import RateReview from "@material-ui/icons/RateReview";
import HomeDashboard from 'components/HomeDashboard';
import ReviewsSection from 'components/ReviewsSection';
import ComingSoon from 'components/ComingSoon'
import PublicIcon from '@material-ui/icons/Public';
import ClientsPage from 'pages/clients'
import PaymentsPage from 'pages/payments'
import SharePage from 'pages/share'
import BusinessSettingsPage from 'pages/businessSettings'
import SettingsIcon from '@material-ui/icons/Settings';
import PackagesPage from 'pages/packages'
import PeopleIcon from '@material-ui/icons/People';
import ListIcon from '@material-ui/icons/List';
import ChallengesPage from 'pages/challenges'
import OnDemandPage from 'pages/ondemand'
import CouponsPage from 'pages/coupons'
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import {ConnectionsPage} from 'components/Connections/PartnerConnections'
import ReferralsPage from 'pages/referrals'
// import CardGiftcardIcon from '@material-ui/icons/CardGiftcard'
// import TimerIcon from '@material-ui/icons/Timer';
import 'components/BookingsDashboard.scss'
import CommunityPage from 'pages/community';

var dashRoutes = [
    {
        path: "/home",
        name: "Home",
        icon: HomeIcon,
        component: HomeDashboard,
        layout: "/dashboard"
    },
    {
        path: "/packages",
        name: "Packages & Subscriptions",
        icon: SubscriptionsIcon,
        component: PackagesPage,
        layout: "/dashboard"
    },
    {
        path: "/promotions",
        name: "Gifts & Promos",
        icon: CardGiftcardIcon,
        component: CouponsPage,
        layout: "/dashboard"
    },
    {
        path: "/on-demand",
        name: "On Demand",
        icon: OndemandVideoIcon,
        component: OnDemandPage,
        layout: "/dashboard"
    },
    {
        path: "/network",
        name: "Instructor Networks",
        icon: PublicIcon,
        component: ConnectionsPage,
        layout: "/dashboard"
    },
    // {
    //     path: "/referrals",
    //     name: "Referrals",
    //     icon: PublicIcon,
    //     component: ReferralsPage,
    //     layout: "/dashboard"
    // },
    {
        path: "/communities",
        name: "Communities",
        icon: PeopleIcon,
        component: ChallengesPage,
        layout: "/dashboard"
    },
    {
        path: "/clients",
        name: "Client List",
        icon: ListIcon,
        component: ClientsPage,
        layout: "/dashboard"
    },
    // {
    //     path: "/share",
    //     name: "Community!",
    //     icon: PublicIcon,
    //     component: SharePage,
    //     layout: "/dashboard"
    // },
    {
        path: "/feedback",
        name: "Testimonials",
        icon: RateReview,
        component: ReviewsSection,
        layout: "/dashboard"
    },
    {
        path: "/revenue",
        name: "Revenue & Bookings",
        icon: AttachMoneyIcon,
        component: PaymentsPage,
        layout: "/dashboard"
    },
    // {
    //     path: "/contact",
    //     name: "Instructor Community",
    //     icon: PublicIcon,
    //     // component: SharePage,
    //     layout: "/dashboard",
    //     uri: "https://community.sutrapro.com/join?invitation_token=45f2aa9b95f882c7b6c548cc958b627bd1e9a932-ef9d5d42-06e6-4c39-9c54-08c117e63866"
    // },
    {
        path: "/settings",
        name: "Settings",
        // path: "/integrations",
        // name: "Integrations",
        icon: SettingsIcon,
        component: BusinessSettingsPage,
        layout: "/dashboard"
    },
    // {
    //     collapse: true,
    //     name: "My Digital Store",
    //     icon: LocalOfferIcon,
    //     state: 'storeCollapse',
    //     views: [
    //         {
    //             path: "/on-demand",
    //             name: "On Demand",
    //             // icon: LocalOfferIcon,
    //             component: Store,
    //             layout: "/dashboard"
    //         },
    //         {
    //             path: "/products",
    //             name: "Products",
    //             // icon: LocalOfferIcon,
    //             component: Store,
    //             layout: "/dashboard"
    //         }
    //     ]
    // },
    // {
    //     path: "/subscription",
    //     name: "Subscription",
    //     icon: LocalOfferIcon,
    //     component: BusinessPage,
    //     layout: "/dashboard"
    // },
    
    // {
    //     path: "/spacer",
    //     name: "",
    //     component: ComingSoon,
    //     layout: "/dashboard"
    // },
    // {
    //     path: "/spacer",
    //     name: "",
    //     component: ComingSoon,
    //     layout: "/dashboard"
    // },
    // {
    //     path: "/spacer",
    //     name: "",
    //     component: ComingSoon,
    //     layout: "/dashboard"
    // },
    // {
    //     path: "/business-settings",
    //     name: "Business Settings",
    //     icon: SettingsIcon,
    //     component: BusinessPage,
    //     layout: "/dashboard"
    // },
    // {
    //     path: "/schedule",
    //     name: "Bookings",
    //     icon: AttachMoneyIcon,
    //     component: BookingsDashboard,
    //     layout: "/dashboard"
    // },
    // {
    //     // collapse: true,
    //     path: "/scheduling",
    //     name: "Add a class",
    //     icon: InsertInvitationIcon,
    //     component: Services,
    //     layout: "/dashboard"

    //     // state: 'scheduleCollapse',
    //     // views: [
    //     //     {
    //     //         path: "/services",
    //     //         name: "Service Types",
    //     //         component: Services,
    //     //         layout: "/dashboard"
    //     //     },
    //     //     {
    //     //         path: "/live",
    //     //         name: "Live Experiences",
    //     //         component: LiveStore,
    //     //         layout: "/dashboard"
    //     //     }
    //     // ]
    // },
    // {
    //     path: "/faq",
    //     name: "FAQ",
    //     icon: HelpOutlineIcon,
    //     component: StudioInformation,
    //     layout: "/dashboard",
    //     uri: "https://sutrahelp.freshdesk.com/support/home"
    // },
    // {
    //     path: "/terms",
    //     name: "Terms of Service",
    //     mini: "",
    //     component: StudioInformation,
    //     layout: "/dashboard",
    //     uri: "https://www.sutra.fit/terms"
    // },
    // {
    //     path: "/contact",
    //     name: "Contact Us",
    //     mini: "",
    //     component: StudioInformation,
    //     layout: "/dashboard",
    //     uri: "https://sutrahelp.freshdesk.com/support/tickets/new"
    // }
    // {

    // },
    {
        path: "/contact",
        name: "FAQs",
        mini: "",
        component: ComingSoon,
        layout: "/dashboard",
        uri: "http://help.sutrapro.com"
    }
];

export default dashRoutes